var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconXml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 16V8V0H5.90368H11.1406L13.1643 2.02366L15.1881 4.04732V10.0237V16H7.92741H0.666748ZM1.86106 14.8057V8V1.19431H6.25439H10.6477L12.3207 2.86726L13.9938 4.54021V9.67295V14.8057H7.92741H1.86106ZM5.24074 9.30331L4.68998 10.4234L4.13922 9.30331H3.21357L4.1531 10.9741L3.18811 12.6727H4.12302L4.68998 11.5318L5.25694 12.6727H6.19416L5.22686 10.9741L6.16871 9.30331H5.24074ZM8.27919 11.6475L7.5271 9.30331H6.46029V12.6727H7.27255V11.8859L7.19387 10.2729L8.01076 12.6727H8.54763L9.36221 10.2752L9.28353 11.8859V12.6727H10.0981V9.30331H9.02897L8.27919 11.6475ZM12.8427 12.0479H11.4287V9.30331H10.6165V12.6727H12.8427V12.0479Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXml);
export default __webpack_public_path__ + "static/media/icon--xml.9761bec7308a1f7e8360e42da900365e.svg";
export { ForwardRef as ReactComponent };